'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { ButtonLink } from '@/components/ui/button'
import { trackCta } from '@/lib/analytics/track-cta'

export function NavCta({ href, label }: { href: string; label: string }) {
  return (
    <ButtonLink href={href} size="md" onClick={() => trackCta('site-nav', label)}>
      {label}
    </ButtonLink>
  )
}
